import React, { useId } from 'react';
import styles from './Textarea.module.css';

/**
 * Стандартизированный компонент Textarea с опциональным label.
 */
const Textarea = ({ label, id, className, wrapperClassName, isInvalid, ...props }) => {
    const autoId = useId();
    const textareaId = id || autoId;

    const textareaClassName = `${styles.textarea} ${isInvalid ? styles.invalid : ''} ${className || ''}`.trim();
    const wrapperClass = `${styles.wrapper} ${wrapperClassName || ''}`.trim();


    return (
        <div className={wrapperClass}>
                  {label && (
                      <label htmlFor={textareaId} className={styles.label}>
                          {label}
                      </label>
                  )}
                      <textarea
                          id={textareaId}
                          className={textareaClassName}
                          {...props}
                      ></textarea>
        </div>
    );
};

export default Textarea;
